import { __extends } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import BookingOptionService from '@/modules/booking-options/BookingOptionService';
var bookingOption = {
  title: '',
  description: '',
  answers: [],
  is_multiple: false
};

var BookingOptionModel =
/** @class */
function (_super) {
  __extends(BookingOptionModel, _super);

  function BookingOptionModel() {
    var _this = _super.call(this, bookingOption, BookingOptionService) || this;

    _this.modelName = 'OpcionesReservas';
    _this.request = 'JSON';
    return _this;
  }

  return BookingOptionModel;
}(BaseModel);

export default BookingOptionModel;